import { Formik, Form, Field, ErrorMessage } from "formik";
import {useState, useRef } from 'react';
import * as Yup from "yup";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/mb_mailer.png";

export default function Contact() {
    const [captchaToken, setCaptchaToken] = useState("");
    const handleCaptcha = (token) => setCaptchaToken(token);
  const navigate = useNavigate();
  const recaptchaRef = useRef();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4">
      <div className="w-[35%]">
        <img src={Logo} alt="MBMailer Logo" />
      </div>
      <div className="w-full max-w-md bg-white p-8 rounded-lg shadow">
        <h2 className="text-2xl font-bold text-center mb-6">Contact Us</h2>
        <Formik
          initialValues={{ name: "", email: "", subject: "", message: "" }}
          validationSchema={Yup.object({
            name: Yup.string().required("Name is required"),
            email: Yup.string().email("Invalid email").required("Email is required"),
            subject: Yup.string().required("Subject is required"),
            message: Yup.string().min(10, "Message must be at least 10 characters").required("Message is required"),
          })}
          onSubmit={async (values, { resetForm }) => {
            const newValues = {
                ...values,
                captchaToken
            }
            try {
              await axios.post("https://mbmailer.mb-techs.com/mbmailer/contact", newValues, {withCredentials: true});
              toast.success("📨 Message sent successfully!");
              resetForm();
              setTimeout(() => navigate("/"), 3000);
            } catch (err) {
              toast.error(err?.response?.data?.error || "Failed to send message.");
            }
          }}
        >
          <Form className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Name</label>
              <Field
                name="name"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage name="name" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <Field
                name="email"
                type="email"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Subject</label>
              <Field
                name="subject"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage name="subject" component="div" className="text-red-500 text-sm mt-1" />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <Field
                name="message"
                as="textarea"
                rows="4"
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
              <ErrorMessage name="message" component="div" className="text-red-500 text-sm mt-1" />
            </div>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_GOOGLE_ID}
                onChange={handleCaptcha}
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
            >
              Send Message
            </button>
          </Form>
        </Formik>
        <ToastContainer position="top-center" autoClose={3000} />
      </div>
    </div>
  );
}
